var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"color":"transparent","top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({},on),[_vm._v("mdi-information-outline")])]}}])},[_c('v-card',{attrs:{"width":"300"}},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.definition)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }